<div class="popup-content container-icon" [ngClass]="isShow && 'container-icon-active'" [formGroup]="editForm">
    <h3>Thêm link</h3>
    <div class="form-group">
        <label>Link</label>
        <div class="d-flex flex-column">
            <input class="form-control" formControlName="link" placeholder="VD: https: //...">
            <app-error-text [isDisplay]="isSaved && !editForm.value.link"
                [message]="'Link là bắt buộc'"></app-error-text>
        </div>
    </div>
    <div class="form-group">
        <label>Tiêu đề</label>
        <div class="d-flex flex-column">
            <input class="form-control" formControlName="title" placeholder="VD: Tại đây, Link, Xem ngay..."
            [ngClass]="{'custom-disabled': editForm.value.image}">
        </div>
    </div>
    <div class="form-group custom">
        <label>Hình ảnh</label>
        <div class=" d-flex flex-column">
            <input id="file-upload" #fileInput style="display: none;" name="file" type="file" ng2FileSelect
                [uploader]="uploader" />
            <div class="d-flex flex-column">
                <div class="d-flex">
                    <button class="form-control btn btn-primary btn-attach mr-4" [disabled]="editForm.value.title"
                        (click)="fileInput.click();"><i class="fas fa-paperclip"></i>Upload</button>
                    <div class="image-container" *ngIf="editForm.value.image">
                        <img [src]="editForm.value.image" width="100" height="100">
                        <img class="view-full-icon" src="./assets/images/icons/view-full.png"
                            (click)="viewImage('', editForm.value.image)">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="form-group"><em>Nhập 1 trong 2 tiêu đề hoặc hình ảnh</em></div>

    <div class="group__btn">
        <button class="ant-btn ng-star-inserted ant-btn-default" (click)="close()">Đóng</button>
        <button class="ant-btn ng-star-inserted ant-btn-primary" (click)="save()">Add link</button>
    </div>
</div>